export const PARENT_SLICE_NAME = 'scheduleBuilderSchedule' as const;
export const SLICE_NAME = 'eventQuotas' as const;
